import { Type } from './types.mjs';
import { createElement } from '../../../../core/utilities/nodes/elements/createElement.mjs';

const validTargets = ['_blank', '_self', '_parent', '_top'];
const PROTOCOL_BLOCKLIST = ['javascript:'];
function isValidTarget(maybeTarget) {
  if (!maybeTarget) {
    return false;
  }
  return validTargets.includes(maybeTarget);
}
function getLinkData({
  target,
  title,
  url
}) {
  return {
    target,
    title,
    url
  };
}
function isSameLink(link1, link2) {
  return JSON.stringify(getLinkData(link1)) === JSON.stringify(getLinkData(link2));
}
function createLinkElement(data, text) {
  return createElement(Type, {
    ...data
  }, text ? [{
    text
  }] : []);
}
function isBlockedProtocol(href) {
  try {
    const url = new URL(href);
    return PROTOCOL_BLOCKLIST.includes(url.protocol);
  } catch {
    return false;
  }
}
function isValidProtocol(href, allowedProtocols) {
  try {
    const url = new URL(href);
    const isBlocked = PROTOCOL_BLOCKLIST.includes(url.protocol);
    const isAllowed = !allowedProtocols || allowedProtocols.includes(url.protocol);
    return !isBlocked && isAllowed;
  } catch {
    /*
      In the case of an invalid URL, if allowedProtocols is set we return false. If it's not set, we return true,
      as it's the consumer's responsibility to decide the URLs they want to allow.
      Example: shopify.com will throw since it's a relative URL/has no protocol but it's still a valid URL when passed
      as an href value
    */
    return !allowedProtocols;
  }
}

export { createLinkElement, getLinkData, isBlockedProtocol, isSameLink, isValidProtocol, isValidTarget };
